import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  getListReportRestaurant,
  getUrlExportRestaurant,
  requestOrderReport,
  setExportInfoRestaurant,
} from './actions';
import { trans } from '../../../localization/index';
import ExportRestaurantFilter from './components/ExportRestaurantFilter';
import ExportRestaurantTable from './components/ExportRestaurantTable';
import {
  changeFilters,
  changeTableActivePage,
  changeTablePageSize,
} from '../../../redux/genericAction';
import { EnumPage } from '../../../constants/enum';
import { NOW_ORDER_MQTT_TOPIC } from '../../../constants/constants';
import { withMqtt } from '../../../components/HOC/ConnectMqtt';

import './ExportRestaurant.scss';

class ExportRestaurant extends Component {
  static contextTypes = {
    mqtt: PropTypes.object,
  };

  componentDidMount() {
    const { getListReportRestaurantConnect } = this.props;
    getListReportRestaurantConnect();
    this.handleSubscribeMqtt();
  }

  componentWillUnmount() {
    this.handleUnsubscribeMqtt();
  }

  handleSubscribeMqtt = () => {
    const { user } = this.props;
    const { username } = user;
    const { mqtt } = this.context;
    const topic = NOW_ORDER_MQTT_TOPIC + username;
    mqtt.subscribe(topic);
  };

  handleUnsubscribeMqtt = () => {
    const { user } = this.props;
    const { username } = user;
    const { mqtt } = this.context;
    const topic = NOW_ORDER_MQTT_TOPIC + username;
    mqtt.unsubscribe(topic);
  };

  render() {
    const {
      restaurants,
      exportRestaurant,
      handleChangeFiltersConnect,
      changeTablePageSizeConnect,
      changeTableActivePageConnect,
      requestOrderReportConnect,
      setExportInfoRestaurantConnect,
      getUrlExportRestaurantConnect,
    } = this.props;
    const { filters, table } = exportRestaurant;
    return (
      <React.Fragment>
        <h2 className="title-page">{trans('mod_export_restaurant')}</h2>
        <ExportRestaurantFilter
          filters={filters}
          restaurants={restaurants}
          handleChangeFilters={handleChangeFiltersConnect}
          requestOrderReport={requestOrderReportConnect}
        />
        <ExportRestaurantTable
          table={table}
          changePageSize={changeTablePageSizeConnect}
          changeActivePage={changeTableActivePageConnect}
          setExportInfoRestaurant={setExportInfoRestaurantConnect}
          getUrlExportRestaurant={getUrlExportRestaurantConnect}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({
  restaurants: state.app.restaurants,
  currentRestaurant: state.setting.currentRestaurant,
  exportRestaurant: state.report.export,
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => {
  const PAGE = EnumPage.EXPORT_RESTAURANT.id;
  return {
    changeTablePageSizeConnect: pageSize =>
      dispatch(changeTablePageSize(PAGE, pageSize)),
    changeTableActivePageConnect: activePage =>
      dispatch(changeTableActivePage(PAGE, activePage)),
    handleChangeFiltersConnect: (name, value) => {
      dispatch(changeFilters(PAGE, name, value));
    },
    getListReportRestaurantConnect: () => dispatch(getListReportRestaurant()),
    requestOrderReportConnect: () => dispatch(requestOrderReport()),
    setExportInfoRestaurantConnect: exportItem =>
      dispatch(setExportInfoRestaurant(exportItem)),
    getUrlExportRestaurantConnect: (reportId) => {
      dispatch(getUrlExportRestaurant(reportId));
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withMqtt(ExportRestaurant)),
);



// WEBPACK FOOTER //
// ./foody/src/pages/Order/ExportRestaurant/ExportRestaurant.jsx